import { useCallback, useEffect } from 'react';
import { useTaskStore } from '@/stores/taskStore';
import { useAgentStore } from '@/stores/agentStore';
import { eventBus, CanvasEvents } from '@/utils/eventBus';
import { createLocalId } from '../helpers';
import { useTaskUpdates } from './useTaskUpdates';

export function useAgentStream() {
  const { handleTaskCompleted, handleTaskStatusChanged } = useTaskUpdates();

  // 监听任务完成和状态变更事件
  useEffect(() => {
    eventBus.on(CanvasEvents.AGENT_TASK_COMPLETED, handleTaskCompleted);
    eventBus.on(CanvasEvents.AGENT_TASK_STATUS_CHANGED, handleTaskStatusChanged);
    return () => {
      eventBus.off(CanvasEvents.AGENT_TASK_COMPLETED, handleTaskCompleted);
      eventBus.off(CanvasEvents.AGENT_TASK_STATUS_CHANGED, handleTaskStatusChanged);
    };
  }, [handleTaskCompleted, handleTaskStatusChanged]);

  // 初始化时检查运行中的任务，恢复挂起的生成状态
  useEffect(() => {
    const taskStore = useTaskStore.getState();
    const agentRunningTasks: any[] = [];
    taskStore.pendingTasks.forEach((task: any) => {
      if (task.status === 'RUNNING' && task.nodeId && task.nodeId.startsWith('agent-node-')) {
        agentRunningTasks.push(task);
      }
    });
    if (agentRunningTasks.length > 0) {
      const latestTask = agentRunningTasks[agentRunningTasks.length - 1];
      useAgentStore.getState().setPendingCanvasNodeId(latestTask.nodeId);
      useAgentStore.getState().setMessages(prev => {
        const lastMsg = prev[prev.length - 1];
        if (lastMsg && lastMsg.role === 'model' && lastMsg.type === 'text') {
          return prev;
        }
        return [...prev, {
          id: createLocalId(),
          role: 'model' as const,
          text: '正在恢复生成任务...',
          type: 'text' as const,
          metadata: {
            pendingNodeId: latestTask.nodeId,
            pendingTaskId: latestTask.taskId,
          },
        }];
      });
    }
  }, []);

  return {};
}
